import Modal from 'modal-enhanced-react-native-web'
export default Modal
